import Vue from 'vue/dist/vue.esm';
import Header from '../homepages/assets/javascripts/components/header';
import Footer from '../homepages/assets/javascripts/components/footer';

document.addEventListener('DOMContentLoaded', () => {

  new Vue({
    components: {
      'gk-header': Header,
      'gk-footer': Footer,
    },
    el: '.gk-pages',
    data() {
      return {
        title: 'Berita',
        activeMenu: 'berita',
        current_user: gon.current_user,
      }
    },
  });

});